import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import { segmentReFetchContext } from "context";
import { SelfPacedSidebar } from "components/organisms/SelfPacedSidebar";
import "./index.scss";
import { SelfPacedJoyRide } from "components/molecules/JoyRide/selfPaced";
import { AppFooter } from "components/organisms/AppFooter";

interface IProps {
  theme: "light" | "dark";
}

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

export const SelfPacedMainPage = ({ theme }: IProps) => {

  const [selectedBtn, setSelectedBtn] = useState<SelectedBtnState>({
    "1": true,
    "2": false,
    "3": false,
    "4": false,
  });

  const [selectedSession, setSelectedSession] = useState<
    null | string | { [key: number]: string }
  >({ 0: "Recent and Upcoming Sessions" });

  const [data, setData] = useState<any[]>([]);

  const [page, setPage] = useState<number>(1);

  const [subject, setSubject] = useState<number>(0);

  const selfPacedMainWrapperRef = useRef<any>(null);

  const { pathname } = useLocation();

  useEffect(() => {
    selfPacedMainWrapperRef.current.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={classNames("self-page-main-page-wrapper")}>
      <SelfPacedJoyRide/>
      <SelfPacedSidebar theme={theme} />
      <div
        ref={selfPacedMainWrapperRef}
        className="self-page-content-section-wrapper"
      >
        <div className={classNames("self-page-main-page-detail-section")}>
          <segmentReFetchContext.Provider
            value={{
              data,
              setData,
              selectedBtn,
              setSelectedBtn,
              selectedSession,
              setSelectedSession,
              page,
              setPage,
              subject,
              setSubject
            }}
          >
            <div className="page-content-fill">
              <Outlet />
            </div>
          </segmentReFetchContext.Provider>
          <AppFooter />
        </div>
      </div>
    </div>
  );
};
